import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomSelect from "../../../components/CustomSelect";
import ImgUploadInput from "../../../components/ImgUploadInput";
import { useTheme } from "../../../context/ThemeContext";
import useProviders from "../../../hooks/useProviders";
import clsx from "clsx";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";
import Toggle from "react-toggle";
import useFeatures from "../../../hooks/useFeatures";
import CategoriesSelect from "../../../components/CategoriesSelect";
import ServicesSelect from "../../../components/ServicesSelect";
import ParentProductModal from "../../../components/ParentProductModal";



const ProductsCreate = () => {

    const { setLoading, setCustomAlert } = useFeedBack();

    const navigate = useNavigate();

    const [filters, setFilters] = useState({
        name: '',
        page: 1
    });

    const [data, setData] = useState({
        name: '',
        image: null,
        reference: '',
        providerId: '',
        categoryId: '',
        subCategoryId: '',
        dataSheet: '',
        certificate: '',
        certificateExpiryDate: '',
        notifyCertificateExpiryDays: '',
        description: '',
        code: '',
        sap_code: '',
        provider_code: '',
        price: 0,
        serviceIds: [],
        isReplacement: false,
        parentId: [],
        parent: '',
        productFeatureOptionIds: [],
    });

    const { customMenuToggle } = useTheme();

    const [{ providers, loading }, getProviders] = useProviders({ params: filters }, { useCache: false });

    const [{ features }, getFeatures] = useFeatures({ params: { page: 1, perPage: 100 } }, { useCache: false });

    const [{ data: createData, loading: createLoading }, createProduct] = useAxios({ url: `/products`, method: 'POST' }, { manual: true, useCache: false });

    useEffect(() => {
        setLoading?.({
            show: createLoading,
            message: `Creando Producto`
        });
    }, [createLoading])

    useEffect(() => {
        if (createData) {
            setData((oldData) => {
                return {
                    ...oldData,
                    id: createData?.data?.id,
                    image: null,
                    dataSheet: null,
                    certificate: null
                }
            });
            setCustomAlert({
                title: '¡Operacion Exitosa!',
                severity: 'success',
                message: `El producto fue creado exitosamente.`,
                show: true
            });
            navigate?.(`/productos/${createData?.data?.id}?name=${createData?.data?.name}`)
        }
    }, [createData])

    useEffect(() => {
        customMenuToggle(true);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault?.();

        const formData = new FormData();

        const { parent, parentId, productFeatureOptionIds, ...rest } = data;

        Object.keys(rest).forEach((key, i) => {
            if (key !== 'id') {
                if (key === 'isReplacement') {
                    formData.append(key, data[key] ? 1 : 0);
                } else {
                    if (data[key]) {
                        if (key === 'image' || key === 'dataSheet' || key === 'certificate') {
                            formData.append(key, data[key], data[key].name);
                        } else {
                            if (key === 'serviceIds') {
                                data[key].forEach((id, i) => {
                                    formData.append(`${key}[${i}]`, id);
                                })
                            } else {
                                formData.append(key, data[key]);
                            }
                        }
                    }
                }
            }
        });

        productFeatureOptionIds?.forEach((featureId, i) => {
            formData?.append(`productFeatureOptionIds[${i}]`, featureId);
        })

        if (parentId?.length > 0) {
            formData?.append('parentId', parentId[0]);
        }

        createProduct({ data: formData });
    }

    const handleProvider = (provider) => {
        setData((oldData) => {
            return {
                ...oldData,
                providerId: provider?.id
            }
        });

        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                name: provider?.name
            }
        });
    }

    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            const value = data[e.target.name]?.includes(Number(e.target.value));
            if (value) {
                const newValues = data[e.target.name]?.filter(n => n !== Number(e.target.value));
                setData((oldData) => {
                    return {
                        ...oldData,
                        [e.target.name]: newValues
                    }
                });
            } else {
                setData((oldData) => {
                    return {
                        ...oldData,
                        [e.target.name]: [...data[e.target.name], Number(e.target.value)]
                    }
                });
            }
            return;
        }

        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.type === 'file' ? e.target.files[0] : e.target.value
            }
        })
    }

    return (
        <div className="card" style={{ width: '100%' }}>
            <div className="card-body">
                <div className="basic-form">
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-5">
                            <div className="col-md-6 mb-4">
                                <h5>¿Es un Repuesto?</h5>
                                <Toggle onChange={() => { setData((oldData) => { return { ...oldData, isReplacement: !oldData?.isReplacement } }) }} checked={data?.isReplacement} />
                            </div>
                            <div className="col-md-6 mb-4">
                                <ParentProductModal
                                    data={data}
                                    setData={setData}
                                    name="parentId"
                                />
                            </div>
                            <div className="form-group mb-3 col-md-8">
                                <div className="mb-4">
                                    <label>
                                        <h5>
                                            Nombre del Producto
                                        </h5>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre"
                                        name="name"
                                        autoFocus
                                        value={data?.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label>
                                        Código
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código"
                                        name="code"
                                        value={data?.code}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label>
                                        Código SAP
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código SAP"
                                        name="sap_code"
                                        value={data?.sap_code}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label>
                                        Código de proveedor
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código de proveedor"
                                        name="provider_code"
                                        value={data?.provider_code}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label>
                                        Número de parte
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Número de parte"
                                        name="reference"
                                        value={data?.reference}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label>
                                        Proveedor
                                    </label>
                                    <CustomSelect
                                        options={providers}
                                        optionLabel="name"
                                        inputPlaceholder="Escribe el nombre..."
                                        isLoading={loading}
                                        onSelectValue={handleProvider}
                                        handleInputChange={(e) => {
                                            setFilters((oldFilters) => {
                                                return { ...oldFilters, name: e.target.value }
                                            })
                                        }}
                                        inputValue={filters?.name}
                                    />
                                </div>
                            </div>
                            <div className="form-group mb-3 col-md-4">
                                <label>
                                    <h5>
                                        Imagen Base del Producto
                                    </h5>
                                </label>
                                <ImgUploadInput
                                    style={{ width: '65%' }}
                                    description="imagen del producto"
                                    name="image"
                                    change={handleChange}
                                />
                                <div className="text-center mt-4">
                                    <label className={clsx(['btn mx-1'], {
                                        "btn-primary": !data?.dataSheet,
                                        "btn-success": data?.dataSheet,
                                    })} htmlFor="datasheet-input">
                                        Ficha técnica
                                    </label>
                                    <input type="file" hidden name="dataSheet" onChange={handleChange} id="datasheet-input" />
                                    <label className={clsx(['btn mx-1'], {
                                        "btn-primary": !data?.certificate,
                                        "btn-success": data?.certificate,
                                    })} htmlFor="certificate-input">
                                        Certificado
                                    </label>
                                    <input type="file" hidden name="certificate" onChange={handleChange} id="certificate-input" />
                                </div>
                            </div>
                            {
                                data?.certificate &&
                                <>
                                    <div className="col-md-6 mb-5 form-group animate__animated animate__fadeInLeft">
                                        <label htmlFor="certificate-expiry-input">
                                            Fecha de expiración del certificado
                                        </label>
                                        <input
                                            className="form-control"
                                            type="date"
                                            value={data?.certificateExpiryDate}
                                            name="certificateExpiryDate"
                                            onChange={handleChange}
                                            id="certificate-expiry-input" />
                                    </div>
                                    <div className="col-md-6 mb-5 form-group animate__animated animate__fadeInLeft">
                                        <label htmlFor="certificate-expiry-days-input">
                                            Días para notificar
                                        </label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            value={data?.notifyCertificateExpiryDays}
                                            name="notifyCertificateExpiryDays"
                                            onChange={handleChange}
                                            id="certificate-expiry-days-input" />
                                    </div>
                                </>
                            }
                            <CategoriesSelect
                                data={data}
                                name="categoryId"
                                setData={setData}
                            />
                            <div className="col-md-12 mt-4">
                                <div>
                                    <label>
                                        Precio
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Precio del producto"
                                        name="price"
                                        value={data?.price}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 mt-3">
                                <label>
                                    Descripción
                                </label>
                                <textarea name="description" onChange={handleChange} className="form-control" style={{ height: 120 }} rows={8}></textarea>
                            </div>
                            <div className="mt-4">
                                <h2>
                                    Características
                                </h2>
                                <div className="row">
                                    {
                                        features?.length > 0 ?
                                            features?.map((feature, i) => {
                                                return (
                                                    <div className="col-md-3" key={i}>
                                                        <h5>
                                                            {feature?.name}
                                                        </h5>
                                                        <div
                                                            className="custom-scrollbar scrollbar-primary"
                                                            style={{ maxHeight: '150px', overflowY: 'auto' }}
                                                        >
                                                            {
                                                                feature?.options?.map((option, i) => {
                                                                    return (
                                                                        <div key={i}>
                                                                            <input
                                                                                value={option?.id}
                                                                                type="checkbox"
                                                                                name="productFeatureOptionIds"
                                                                                style={{ cursor: 'pointer' }}
                                                                                checked={data?.productFeatureOptionIds?.includes(option?.id)}
                                                                                onChange={handleChange}
                                                                                className="mx-2"
                                                                                id={`feature-options-${option?.id}`}
                                                                            />
                                                                            <label htmlFor={`feature-options-${option?.id}`} style={{ cursor: 'pointer' }}>
                                                                                {option?.name}
                                                                            </label>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <div className="text-center">
                                                No hay Características.
                                            </div>
                                    }
                                </div>
                            </div>
                            <ServicesSelect
                                data={data}
                                name="serviceIds"
                                setData={setData}
                                multiple
                            />
                        </div>
                        <div className="mb-3 d-flex justify-content-end">
                            <Link to={`#`} onClick={() => { navigate(-1) }} className="btn btn-danger mx-2">
                                Volver
                            </Link>
                            <button type="submit" className="btn btn-primary mx-2">
                                Crear
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default ProductsCreate;